import { makeAllObjToArr, objToArr } from "../../helpers";
import * as actionTypes from "../actionTypes";

const initialState = {
  salesData: null,
  otherIncomeData: null,
  otherIncomeEditData: null,
  orderPaymentsData: null,
  orderPaymentsItemData: null,
  orderPaymentsComponentData: null,
  orderPaymentsBundleItemData: null,
  orderPaymentsViewBillsData: null,
  orderPaymentsBillsItemData: null,
  refundsData: null,
  refundsBillData: null,
  innerMenuItemData: null,
  innerComponentData: null,
  voidsData: null,
  discountsData: null,
  tipsData: null,
  promotionsSalesData: null,
  expensesData: null,
  paymentsData: null,
  addPaymentsFormData: null,
  expenseTypeData: null,
  invoicesData: null,
  payTradeLiabilityData: null,
  payOtherDebtData: null,
  buyAssetData: null,
  paymentAccountData: null,
  addAssetData: null,
  assetFormState: false,
  editAssetFormState: false,
  apLiabilityData: null,
  viewPaymentData: null,
  editPaymentData: null,
  pendingPaymentsData: null,
  rejectedPaymentsData: null,
  submittedPaymentsData: null,
  approvedPaymentsData: null,

  // finance payables
  financePayablesOutstanding: null,
  financeApCreditNotes: null,
  financeApCreditNotesOption: null,
  financeEditApCreditNotesData: null,
  financeAssets: null,

  // finance vouher
  financeVouchers: null,
  financeVouchersList: null,
};

const financeReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case actionTypes.SAVE_FINANCE_VALUES: {
      return { ...state, ...payload };
    }

    case actionTypes.SET_MODAL_STATE: {
      return { ...state, [payload.modalName]: payload.modalState };
    }

    case actionTypes.SET_FORM_STATE: {
      return { ...state, [payload.formName]: payload.formState };
    }

    case actionTypes?.SAVE_SALES_DATA:
      return { ...state, salesData: payload };

    case actionTypes?.SAVE_OTHER_INCOME_DATA_OPTIONS:
      return { ...state, otherIncomeData: makeAllObjToArr(payload) };

    case actionTypes?.SAVE_OTHER_INCOME_DATA:
      return {
        ...state,
        otherIncomeData: { ...state.otherIncomeData, other_income: payload },
      };

    case actionTypes?.SAVE_OTHER_INCOME_EDIT_DATA:
      return { ...state, otherIncomeEditData: payload };

    case actionTypes?.SAVE_ORDER_PAYMENTS_DATA:
      return {
        ...state,
        orderPaymentsData: makeAllObjToArr(payload, ["orders"]),
      };

    case actionTypes?.SAVE_ORDER_PAYMENTS_ITEM_DATA:
      return { ...state, orderPaymentsItemData: payload };

    case actionTypes?.SAVE_ORDER_PAYMENTS_BUNDLE_ITEM_DATA:
      return { ...state, orderPaymentsBundleItemData: payload };

    case actionTypes?.SAVE_ORDER_PAYMENTS_COMPONENT_DATA:
      return { ...state, orderPaymentsComponentData: payload };

    case actionTypes?.SAVE_ORDER_PAYMENTS_VIEW_BILLS_DATA:
      return { ...state, orderPaymentsViewBillsData: payload };

    case actionTypes?.SAVE_REFUNDS_DATA:
      return { ...state, refundsData: makeAllObjToArr(payload, ["orders"]) };

    case actionTypes?.SAVE_REFUNDS_BILL_DATA:
      return { ...state, refundsBillData: payload };

    case actionTypes?.SAVE_INNER_MENU_ITEMS_DATA:
      return { ...state, innerMenuItemsData: payload };

    case actionTypes?.SAVE_INNER_COMPONENT_DATA:
      return { ...state, innerComponentData: payload };

    case actionTypes?.SAVE_VOIDS_DATA:
      return { ...state, voidsData: makeAllObjToArr(payload, ["orders"]) };

    case actionTypes?.SAVE_DISCOUNTS_DATA:
      return { ...state, discountsData: makeAllObjToArr(payload, ["orders"]) };

    case actionTypes?.SAVE_TIPS_DATA:
      return { ...state, tipsData: makeAllObjToArr(payload, ["orders"]) };

    case actionTypes?.SAVE_PROMOTIONS_DATA:
      return {
        ...state,
        promotionsData: makeAllObjToArr(payload, ["promotions"]),
      };

    case actionTypes?.SAVE_PROMOTIONS_SALES_DATA:
      return { ...state, promotionsSalesData: makeAllObjToArr(payload) };

    case actionTypes?.SAVE_EXPENSES_DATA:
      return { ...state, expensesData: payload };

    case actionTypes?.SAVE_PAYMENTS_DATA:
      return { ...state, paymentsData: payload };

    case actionTypes?.SAVE_ADD_PAYMENTS_FORM_DATA:
      return { ...state, addPaymentsFormData: makeAllObjToArr(payload) };

    case actionTypes?.SAVE_EXPENSE_TYPE_DATA:
      return {
        ...state,
        addPaymentsFormData: {
          ...state?.addPaymentsFormData,
          paymentAccounts: objToArr(payload.ap_liability_account),
        },
        expenseTypeData: makeAllObjToArr(payload),
      };

    case actionTypes?.SAVE_INVOICES_DATA:
      return { ...state, invoicesData: makeAllObjToArr(payload) };

    case actionTypes?.SAVE_PAY_TRADE_LIABILITY_DATA:
      return { ...state, payTradeLiabilityData: makeAllObjToArr(payload) };

    case actionTypes?.SAVE_PAY_OTHER_DEBT_DATA:
      return { ...state, payOtherDebtData: payload };

    case actionTypes?.SAVE_BUY_ASSET_DATA:
      return { ...state, buyAssetData: payload };

    case actionTypes?.SAVE_PAYMENT_ACCOUNT_DATA:
      return { ...state, paymentAccountData: makeAllObjToArr(payload) };

    case actionTypes?.SAVE_ADD_ASSET_DATA:
      return { ...state, addAssetData: makeAllObjToArr(payload, ["data"]) };

    case actionTypes?.SAVE_AP_LIABILITY_DATA:
      return { ...state, apLiabilityData: makeAllObjToArr(payload, ["data"]) };

    case actionTypes?.SAVE_VIEW_PAYMENT_DATA:
      return {
        ...state,
        viewPaymentData: makeAllObjToArr(payload, ["payments", "invoice"]),
      };

    case actionTypes?.SAVE_EDIT_PAYMENT_DATA:
      return {
        ...state,
        editPaymentData: makeAllObjToArr(payload, ["payments", "invoice"]),
      };

    case actionTypes?.SAVE_PENDING_PAYMENTS_DATA:
      return {
        ...state,
        pendingPaymentsData: makeAllObjToArr(payload, ["payments", "invoice"]),
      };

    case actionTypes?.SAVE_APPROVED_PAYMENTS_DATA:
      return {
        ...state,
        approvedPaymentsData: makeAllObjToArr(payload, ["payments", "invoice"]),
      };

    case actionTypes?.SAVE_REJECTED_PAYMENTS_DATA:
      return {
        ...state,
        rejectedPaymentsData: makeAllObjToArr(payload, ["payments", "invoice"]),
      };

    case actionTypes?.SAVE_SUBMITTED_PAYMENTS_DATA:
      return {
        ...state,
        submittedPaymentsData: makeAllObjToArr(payload, [
          "payments",
          "invoice",
        ]),
      };

    default:
      return state;
  }
};

export default financeReducer;
